import {
  BookOpen,
  Gavel,
  ScrollText,
  ShieldCheck,
} from "lucide-react";
import { Justiniano } from "@tribunalea/justiniano";

const sourceTypes = [
  {
    label: "Normas",
    detail: "El marco aplicable",
    icon: ScrollText,
  },
  {
    label: "Jurisprudencia",
    detail: "Cómo lo interpretan los tribunales",
    icon: Gavel,
  },
  {
    label: "Doctrina",
    detail: "Las ideas y posiciones de sus autores",
    icon: BookOpen,
  },
];

export function StudyPage({ getAccessToken }) {
  return (
    <main className="lexia-page">
      <section className="lexia-study-surface">
        <header className="lexia-study-header">
          <div className="lexia-study-title">
            <span className="lexia-eyebrow">Espacio de estudio</span>
            <h1>Preguntá. Entendé. Verificá.</h1>
            <p>
              Justiniano conecta las fuentes para ayudarte a comprender el
              derecho, no solamente a encontrar una respuesta.
            </p>
          </div>

          <div className="lexia-source-types" aria-label="Fuentes disponibles">
            {sourceTypes.map(({ label, detail, icon: Icon }) => (
              <div className="lexia-source-type" key={label}>
                <span className="lexia-source-icon" aria-hidden="true">
                  <Icon size={17} />
                </span>
                <span>
                  <strong>{label}</strong>
                  <small>{detail}</small>
                </span>
              </div>
            ))}
          </div>
        </header>

        <div className="lexia-chat-surface">
          <Justiniano
            variant="page"
            appId="lexia"
            appName="Lexia"
            apiUrl={import.meta.env.VITE_API_URL || "http://localhost:4000"}
            getAccessToken={getAccessToken}
            welcome="Preguntame por un tema jurídico. Voy a explicarlo con claridad y, cuando las fuentes disponibles lo permitan, conectar las normas aplicables, su interpretación jurisprudencial y las principales posiciones doctrinarias."
            suggestions={[
              "Explicame la responsabilidad objetiva y sus requisitos",
              "¿Cuál es la diferencia entre nulidad absoluta y relativa?",
              "¿Qué criterios existen sobre el despido discriminatorio?",
            ]}
            appContext={{
              route: "/",
              audience: "law_student",
              learningExperience: true,
            }}
          />
        </div>

        <footer className="lexia-source-note">
          <ShieldCheck size={14} aria-hidden="true" />
          <span>
            Revisá las referencias: la explicación orienta tu estudio y las
            fuentes te permiten comprobarla.
          </span>
        </footer>
      </section>
    </main>
  );
}
